var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04082 11.131H9.43368C9.74596 11.131 9.99915 10.8781 9.99915 10.5656V8.86913C9.99915 8.55657 9.74596 8.30365 9.43368 8.30365H6.04082C5.72854 8.30365 5.47534 8.55657 5.47534 8.86913V10.5656C5.47534 10.8781 5.72854 11.131 6.04082 11.131Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0884 13.9583V12.2619C15.0884 11.9493 14.8352 11.6964 14.523 11.6964H6.04082C5.72854 11.6964 5.47534 11.9493 5.47534 12.2619V13.9583C5.47534 14.2708 5.72854 14.5238 6.04082 14.5238H14.523C14.8352 14.5238 15.0884 14.2708 15.0884 13.9583Z",
    fill: "#8F8C9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3499 15.0891H11.6951C11.3828 15.0891 11.1296 15.342 11.1296 15.6546V17.351C11.1296 17.6636 11.3828 17.9165 11.6951 17.9165H17.3499C17.6622 17.9165 17.9154 17.6636 17.9154 17.351V15.6546C17.9154 15.342 17.6622 15.0891 17.3499 15.0891Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3512 2.08334H2.64885C2.33657 2.08334 2.08337 2.33626 2.08337 2.64882V5.4762V7.17263V17.3512C2.08337 17.6638 2.33657 17.9167 2.64885 17.9167C2.96113 17.9167 3.21433 17.6638 3.21433 17.3512V7.73811H6.04171C6.35399 7.73811 6.60718 7.48519 6.60718 7.17263V5.4762C6.60718 5.16364 6.35399 4.91072 6.04171 4.91072H3.21433V4.34525H17.3512C17.6635 4.34525 17.9167 4.09233 17.9167 3.77977V2.64882C17.9167 2.33626 17.6635 2.08334 17.3512 2.08334Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.85ca2648e122bba04f10a8ffc9fcb520.svg";
export { ForwardRef as ReactComponent };